import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyPageSeo } from "../constants/seo";
import { injectStructuredData } from "../constants/structuredData";

/**
 * Updates title, meta description, canonical, Open Graph, Twitter tags, and JSON-LD per route.
 */
export default function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "") || "/";
    applyPageSeo(pathname);
    injectStructuredData(path);
  }, [pathname]);

  return null;
}
